<template>
    <div v-if="toolsContentShow" class="box">
        <div class="box3" @click="$emit('clear')">
            <svg viewBox="0 0 40 40">
                <path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30"></path>
            </svg>
        </div>
        <div class="box-overflow">
            <img src="../assets/images/dnstop.png"/>
            <p><a href="http://jingyan.baidu.com/article/2c8c281df7e5d90009252a6d.html" target="_blank">http://jingyan.baidu.com/article/2c8c281df7e5d90009252a6d.html</a> </br>
            如果您是<span>win7/win8/win10</span>系统，请您打开该链接，根据步骤提示修改DNS。请将首选DNS设置成8.8.8.8，备用DNS设置成8.8.4.4 </p>

            <p><a href="http://jingyan.baidu.com/article/0a52e3f4007606bf62ed7292.html" target="_blank">http://jingyan.baidu.com/article/0a52e3f4007606bf62ed7292.html</a> </br>
            如果您是<span>xp</span>系统，请您打开该链接，根据步骤提示修改DNS。请将首选DNS设置成8.8.8.8，备用DNS设置成8.8.4.4 </p>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: ['toolsContentShow']
}
</script>

<style scoped>
.box {
    position: fixed;
    top: 40%;
    left: 50%;
    margin-left: -305px;
    margin-top: -315px;
    width: 610px;
    background: rgb(217, 217, 217);
    box-shadow: 0px 0px 3px 2px white;
    border: 1px solid white;
    word-break: break-all;
    z-index: 99999999;
}

.box-overflow {
    max-height: 700px;
    min-height: 630px;
    overflow-y: visible;
    overflow-x: hidden;
}

.box3 {
    right: 130px;
    width: 30px;
    height: 30px;
    -moz-transition: all .5s ease;
    -o-transition: all .5s ease;
    -webkit-transition: all .5s ease;
    transition: all .5s ease;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 20px;
}

.rotate {
    /* animation: changeFontSize 3s ease-in-out 0s infinite; */
}

@keyframes changeFontSize {
    30% {
        transform: rotate(0deg);
    }
    60% {
        transform: rotate(90deg);
    }
}


.box3:hover {
    -moz-transform: rotate(190deg);
    -ms-transform: rotate(190deg);
    -o-transform: rotate(190deg);
    -webkit-transform: rotate(190deg);
    transform: rotate(190deg);
}

.close-x {
    stroke: black;
    fill: transparent;
    stroke-linecap: round;
    stroke-width: 5;
}

.pic-bottom {
    background: #ccc;
    color: #fff;
    background: url('../assets/images/Promotion_bar.png') no-repeat;
    background-color: #383431;
    height: 34px;
    line-height: 34px;
    padding-left: 20px;
    background-size: 100%;
    cursor: pointer;
    border-top: 1px solid white;
}

.pic-bottom span {
    color: yellow;
}

h3,
h4,
h5 {
    text-align: center;
}

.box img {
    width: 100%;
    border-top: 1px solid white;
}

.box .content {
    padding: 0px 15px 15px 15px;
    font-size: 15px;
    line-height: 26px;
    letter-spacing: 2px;
    /* text-indent: 2em; */
    /* border: 1px solid #ccc; 
    box-shadow: 0 0 3px 0px #383431 inset;
    height: 100%; */
}

.box .content ul {
    text-indent: 2em;
}

ul {
    list-style-type: none;
}

p{
    text-align: left;
    padding: 20px;
}

p::before{
    content: '';
    display: inline-block;
    padding: 10px;
    box-sizing: border-box;
    height: 25px;
    width: 25px;
    line-height: 6px;
    text-align: center;
    color: #fff;
    margin-right:10px; 
    border-radius: 40px;
    /* position: absolute;
    top: 0;
    left: 0; */
}
p:nth-child(2)::before{
    content: '1';
    background: rgba(249, 107, 107, 0.8);
}
p:nth-child(3)::before{
    content: '2';
    background: rgba(89, 149, 216, 0.8);
}


p a{
    color:blue;
}

p span{
    color: green;
    font-weight:bold; 
}
</style>







// WEBPACK FOOTER //
// src/components/c.game.tools.content.vue